module.exports = __webpack_public_path__ + "static/img-testimonial-Cabanillas-7327a3a7c725af7134c001dea094ba82.jpg";